var redskinsYouTubeVideoContentSwiperMobile = new Swiper("#redskinsYouTubeVideoContentSwiperMobile", {
        slidesPerView: 'auto',
        spaceBetween: 16,
        touchRatio:1.5,
    });

    function youtubeVideoDivMouseDownMobile(url){
        var videoHtml = '<iframe width="100%" height="100%" src="' + url + '?enablejsapi=1&autoplay=1&fs=1&playsinline=0" class="youtube-player youtubeVideo redskinsYouTubeVideoIframeMobile" frameborder="0" ></iframe>';
        $(".redskinsYouTubeVideoPopupDivMobile").prepend(videoHtml);
        $(".redskinsYouTubeVideoPopupShowDivMobile").show();
    }

    $(".redskinsYouTubeVideoCloseMobile").click(function() {
        $(".redskinsYouTubeVideoPopupShowDivMobile").hide();
        $(".redskinsYouTubeVideoIframeMobile").remove();
    })